<template>
    <Badge :color="customColor" :icon="value ? 'check-circle' : 'times-circle'">
        {{ value ? textOn : textOff }}
    </Badge>
</template>

<script>
import Badge from "../Badge";

export default {
    name: "Boolean",
    props: {
        value: {
            Boolean,
        },
        textOn: {
            type: String,
            default: "Yes",
        },
        textOff: {
            type: String,
            default: "No",
        },
        color: {
            type: String,
        },
    },
    components: {
        Badge,
    },
    computed: {
        customColor() {
            if (this.color) return this.color;
            return this.value ? "success" : "secondary";
        },
    },
};
</script>
